<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-row style="background-color: #f3f4f4">
      <el-col :xs="24" :md="6" style="
          line-height: 40px;
          font-size: 16px;
          color: #121212;
          font-weight: bold;
        "><img style="width: 16px; height: 16px; margin-right: 12px" src="../../../assets/img/user-list.png" />员工管理
      </el-col>
      <el-col :xs="24" :md="18">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right">
          <el-form-item>
            <el-button v-if="
                $hasPermission('user:userList:save') &&
                  dataForm.userType != 'gryh'
              " class="addBtn" type="primary" @click="addOrUpdateHandle1()">{{ $t("add") }}(员工用户)</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-no-more-click class="addBtn" type="info" @click="$router.go(-1)" >返回</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <div class="mod-sys__user">
      <el-row style="border-bottom: 3px solid #f3f4f4; padding-bottom: 10px">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item style="margin-top: 20px; margin-left: 20px" label="用户名:">
            <el-input v-model="dataForm.username" placeholder="用户名" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 20px; margin-left: 20px">
            <el-button type="primary" @click="getDataList()">执行{{ $t("query") }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle"
        @sort-change="dataListSortChangeHandle" style="width: 100%">
        <el-table-column type="selection" key="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="username" key="username" label="用户名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realName" key="realName" label="员工姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobile" key="mobile" label="手机号" header-align="center" align="center">
        </el-table-column>
        
        <el-table-column prop="createDate" key="createDate" label="操作日期" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="isEnable" key="isEnable" :label="$t('user.status')" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" size="small" type="danger">{{ $t("user.status0") }}
            </el-tag>
            <el-tag v-else size="small" type="success">{{
              $t("user.status1")
              }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="250">
          <template slot-scope="scope">
            <el-button v-if="
                scope.row.status === 0 && $hasPermission('user:userList:update')
              " type="text" size="small" @click="
                $hasPermission('user:userList:update') &&
                  enableOrDisableHandle(scope.row.id, 1)
              ">
              启用
            </el-button>
            <el-button v-if="
                scope.row.status === 1 && $hasPermission('user:userList:update')
              " type="text" size="small" @click="
                $hasPermission('user:userList:update') &&
                  enableOrDisableHandle(scope.row.id, 0)
              ">
              停用
            </el-button>
            <el-button v-if="
                $hasPermission('user:userList:update') &&
                  scope.row.userType == 'qyyh'
              " type="text" size="small" @click="addOrUpdateHandle1(scope.row.id)">{{ $t("update") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
        layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="addOrUpdateVisible = false;getDataList()"></add-or-update>
    </div>
  </el-card>
</template>

<script>
  import mixinViewModule from "@/mixins/view-module";
  import AddOrUpdate from "./user-edit-staff";
  import Open from "./open-account";
  import Cookies from "js-cookie";
  export default {
    mixins: [mixinViewModule],
    data() {
      return {
        mixinViewModuleOptions: {
          // pageList
          getDataListURL: "/sys/user/getCompanyUsers",
          getDataListIsPage: true,
          deleteIsBatch: true,
        },
        role: Cookies.get("admin_role"),
        dataForm: {
          username: "",
          caId:JSON.parse(this.$route.params.rowObj).caId
        },
      };
    },
    components: {
      AddOrUpdate,
    },
    created() { 
    },
    methods: {
      // 新增 / 修改
      addOrUpdateHandle1 (id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          
          this.$refs.addOrUpdate.dataForm.caName = JSON.parse(this.$route.params.rowObj).caName
          this.$refs.addOrUpdate.dataForm.simpleName = JSON.parse(this.$route.params.rowObj).simpleName
          this.$refs.addOrUpdate.dataForm.id = id ? id : ''
          this.$refs.addOrUpdate.dataForm.caId = JSON.parse(this.$route.params.rowObj).caId
          this.$refs.addOrUpdate.init()
        })
      },
      enableOrDisableHandle(id, isEnable) {
        this.$confirm(
          "此操作将" + isEnable == 0
            ? "将禁用"
            : "将启用" + "此条数据, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.handle(id, isEnable);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      },
      handle(id, isEnable) {
        this.$http
          .get(`/sys/user/enableOrDisable?id=${id}&status=${isEnable}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg);
            } else {
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.query();
                },
              });
            }
          })
          .catch(() => { });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .batchImport {

    /deep/ .el-list-enter-active,
    /deep/ .el-list-leave-active {
      transition: none;
    }

    /deep/ .el-list-enter,
    /deep/ .el-list-leave-active {
      opacity: 0;
    }

    /deep/ .el-upload-list {
      height: 40px;
    }
  }
</style>